import { useNavigate, useSearchParams } from 'react-router-dom';
import { AdvanceReportForm } from '../../components/AdvanceReportForm';

export function AdvanceLoggerPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialProjectId = searchParams.get('projectId') ?? '';

  return (
    <div className="space-y-4 max-w-lg mx-auto">
      <div>
        <h1 className="text-xl font-bold text-slate-900">Registrar Avance</h1>
        <p className="text-xs text-slate-500">Reporta el progreso semanal de la obra</p>
      </div>

      <AdvanceReportForm
        initialProjectId={initialProjectId || undefined}
        onSuccess={() => navigate('/gestion/avances', { replace: true })}
        onCancel={() => navigate(-1)}
      />
    </div>
  );
}